<template>
	<div class="journeys-skew-banner">
		<div class="container">
			<div class="row">
				<div class="col journeys-skew-banner__content text-center">
					<h1 class="h2">{{ mainTitle }}</h1>

					<p v-if="subtitle">
						{{ subtitle }}
					</p>
				</div>
			</div>
		</div>
	</div>
	<div class="container pull-up">
		<form
			class="w-100"
			@submit.prevent
		>
			<div class="rounded-container">
				<div class="row">
					<div class="col rounded-container__btn-col d-flex flex-column text-center">
						<span v-html="body"></span>
					</div>
				</div>
			</div>
			<div class="row btm-btn-group m-auto mb-5">
				<div class="col text-center d-flex flex-column align-items-center">
					<GenericButton
						:button-disabled="buttonDisabled"
						@button-click="handleClick"
						:label-text="buttonText"
					/>
				</div>
			</div>
		</form>
	</div>
</template>

<script>
import GenericButton from '@/shared/components/GenericButton.vue';

import router from '../router/index.js';

import { mapActions } from 'pinia';
import { useAppointmentReferralStore } from '../stores/appointmentReferralStore.js';

export default {
	components: {
		GenericButton,
	},
	data() {
		return {
			buttonDisabled: false,
			microcopy: null
		};
	},
	props: {
		unableToMatchCustomerDetails: {
			type: Boolean,
			default: false,
		},
		cantFindFinancialAdviser: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		body() {
			return this.microcopy?.body;
		},
		subtitle() {
			return this.microcopy?.subtitle;
		},
		mainTitle() {
			return this.microcopy?.heading;
		},
		desktopButtonText() {
			return this.microcopy?.desktopButtonText;
		},
		mobileButtonText() {
			return this.microcopy?.mobileButtonText;
		},
		buttonText() {
			window.mobileCheck = function () {
				let check = false;
				(function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true; })(navigator.userAgent || navigator.vendor || window.opera);
				return check;
			};

			return window.mobileCheck() ? this.mobileButtonText : this.desktopButtonText
		},
	},
	methods: {
		...mapActions(useAppointmentReferralStore, ['postCustomerType', 'resetExistingCustomerDetails']),
		handleClick() {
			this.$emit('button-click');
			this.postCustomerType(false)
			this.resetExistingCustomerDetails();
			this.nextPage()
		},
		nextPage() {
			if (this.buttonText.includes('Try') || this.buttonText.includes('Find')) {
				router.push('customer-type');
			}
			else {
				window.location.href = 'https://www.wesleyan.co.uk';
			}
		},
	},
	mounted() {
		if (!this.unableToMatchCustomerDetails && !this.cantFindFinancialAdviser) {
			document.querySelectorAll('.step--confirmation').forEach(elem => elem.classList.remove('d-none'));
		}
		if (this.unableToMatchCustomerDetails) {
			this.microcopy = window.bookAnAppointmentReferralMicrocopy.cannotMatchCustomer;
		}
		else if (this.cantFindFinancialAdviser) {
			this.microcopy = window.bookAnAppointmentReferralMicrocopy.formUnavailable;
		}
		else {
			this.microcopy = window.bookAnAppointmentReferralMicrocopy.confirmationPage;
		}
	},
	unmounted() {
		document.querySelectorAll('.step--confirmation').forEach(elem => elem.classList.add('d-none'));
	}
};
</script>
